import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosGigiPassagens = {
    ...dadosAgenciaComum,
    id: 'gigipassagens',
    nome: 'Gigi Passagens',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-W2BW4Z8']
};
